import * as React from 'react';
import * as jQuery from 'jquery';
import { Button, Icon, Image } from 'semantic-ui-react'
import reportIcon from "../../../images/help-icons/icon-help-reportissue.svg";
const loadIssueCollector = (function () {
  // const COLLECTOR_ID = '13a7923b';
  const ISSUE_COLLECTOR_URL = process.env.REACT_APP_JIRA_COLLECTOR_URL;
  let showIssueCollector = null;
  return () => {
    if (!showIssueCollector) {
      showIssueCollector = new Promise(resolve => {
        window.ATL_JQ_PAGE_PROPS = {
          triggerFunction(showIssueCollector) {
            resolve(showIssueCollector);
          },
        };
        jQuery.ajax({
          url: ISSUE_COLLECTOR_URL,
          type: 'get',
          cache: true,
          dataType: 'script',
        });
      });
    }
    return showIssueCollector;
  };
})();

export class FeedbackButton extends React.Component {
  render() {
    const isJQueryAvailable = typeof window.jQuery !== 'undefined';
    if (!isJQueryAvailable) {
      return null;
    }
    const { item } = this.props
    return (

      < div
        className="pad_10 mar_tb_5 bg-white bdr-rds-4 float-left w_100 hoverEffect"
        onClick={this.showFeedbackDialog} >
        <div className="float-left" style={{ width: "32px" }}>
          <Image src={reportIcon} />
        </div>
        <div className="float-left" style={{ width: "calc(100% - 32px)", padding: "0 0 0 20px" }}>
          <h4 className="mar_0">{item.name} </h4>
          <p>{item.description}</p>
        </div>
      </div >
      // <Button className="help_button" onClick={this.showFeedbackDialog}>
      //   <Icon name="bug" />
      //   <div className="iconLabel">Report an Issue </div>
      // </Button>
    );
  }

  showFeedbackDialog = () => {
    loadIssueCollector().then(
      showIssueCollector => {
        showIssueCollector();
      },
      _ => {

      },
    );
  };
}